import { connect } from 'react-redux';
import { CustomQuestion, ICustomQuestionContainerProps } from '../../components/questions/custom-questions/CustomQuestion';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/CustomQuestionStore';
import { UserFeatureAccessHelper } from '../../utilities/FeatureFlags';

export const CustomQuestionContainer: React.ComponentType<ICustomQuestionContainerProps> = connect(
	(state: IApplicationState) => ({
		...state.customQuestion,
		userFeatureAccessHelper: new UserFeatureAccessHelper(state.oidc.user),
	}),
	ActionCreators,
)(CustomQuestion);
